import React from 'react';

import { $config } from '@client/core/atoms/config';

export const ShortStatus = () => {
  const config = $config.get();

  const configItems = [
    { label: 'pageType', value: config?.pageType },
    { label: 'deviceType', value: config?.deviceType },
    { label: 'brand', value: config?.brand },
    { label: 'vertical', value: `${config?.vertical} ${config?.subvertical}` },
    { label: 'consent', value: config?.consent },
    {
      label: 'Adservers',
      value: Object.keys(config?.adServer || {})
        .map((key) => key.toUpperCase())
        .join(', ')
    }
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px',
        padding: '10px'
      }}
    >
      {configItems.map((item, index) => (
        <div key={index} style={{ textAlign: 'center' }}>
          <small style={{ fontSize: '12px', color: '#888' }}>
            {item.label}:
          </small>
          <p style={{ fontSize: '15px', fontWeight: 'bold' }}>{item.value}</p>
        </div>
      ))}
    </div>
  );
};
